import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateNavigationLinks } from "./gsap-footer";

const SiteNavigation = () => {
  const navigationRef = useRef<HTMLDivElement>(null);

  const links = [
    { text: "Home", url: "/" },
    { text: "Products", url: "/products" },
    { text: "About Us", url: "/about" },
    { text: "Blog", url: "/blog" },
    { text: "Locations", url: "/locations" },
    { text: "Contact", url: "/contact" },
    // Commented links can be uncommented when those pages are ready
    // { text: "Login", url: "/login" },
    // { text: "FAQs", url: "/faq" },
  ];

  useEffect(() => {
    let cleanup: (() => void) | undefined;

    if (navigationRef.current) {
      // Add a small delay to ensure footer animation has started
      const timer = setTimeout(() => {
        if (navigationRef.current) {
          cleanup = animateNavigationLinks(navigationRef.current);
        }
      }, 500);

      return () => {
        clearTimeout(timer);
        if (cleanup) {
          cleanup();
        }
      };
    }
  }, []);

  return (
    <>
      <h1 className="text-xl font-bold mb-5 text-cannabis-green-300">
        Site Navigation
      </h1>
      <div ref={navigationRef} className="grid grid-cols-2 gap-x-4 gap-y-3">
        {links.map((link) => (
          <Link
            key={link.url}
            to={link.url}
            className="text-gray-400 hover:text-cannabis-green-300 transition-all duration-300 py-1 px-2 rounded hover:bg-cannabis-green-500/10"
          >
            {link.text}
          </Link>
        ))}
      </div>
    </>
  );
};

export default SiteNavigation;
